export function compact<T>(arg?: null | Array<T | null | undefined>): Array<T> {
  return arg ? (arg.filter((i) => i !== null) as Array<T>) : [];
}
